"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.neo2CNSHash = void 0;
exports.neo2CNSHash = {
    stage: 'b434339f25b6f1bec68e99f620dfbf3ec27dacdc',
    production: 'b434339f25b6f1bec68e99f620dfbf3ec27dacdc',
};
//# sourceMappingURL=blockchain.js.map